

// Import ----------------------------------------------------------------------

// Project
import { VueGlobalInjectable } from "~/libs/Types";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"],

    computed: {
        title (): string {
            return this.node.page?.title ?? this.node.title ?? "";
        },

        subTitle (): string {
            return this.node.page?.headline ?? "";
        }
    }

    // -------------------------------------------------------------------------
});
